var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "icon icon-tabler icons-tabler-outline icon-tabler-crane",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 21h6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21v-18l-6 6h18"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 3l10 6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 9v4a2 2 0 1 1 -2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrane);
export default __webpack_public_path__ + "static/media/crane.83082def2fb252af939691c75c1b2923.svg";
export { ForwardRef as ReactComponent };